import { render, staticRenderFns } from "./RealName.vue?vue&type=template&id=2398d048&scoped=true&"
import script from "./RealName.vue?vue&type=script&lang=ts&"
export * from "./RealName.vue?vue&type=script&lang=ts&"
import style0 from "./RealName.vue?vue&type=style&index=0&id=2398d048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398d048",
  null
  
)

export default component.exports